import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={735}
    height={4}
    fill="none"
    {...props}
  >
    <path stroke="url(#acv)" strokeLinecap="round" strokeWidth={2} d="M1 2h150" />
    <path
      stroke="url(#bcv)"
      strokeLinecap="round"
      strokeWidth={2}
      d="m213.352 2.297 511.647-.298"
    />
    <path fill="url(#ccv)" d="M735 0h4v4h-4z" transform="rotate(90 735 0)" />
    <defs>
      <linearGradient
        id="acv"
        x1={-106}
        x2={405.647}
        y1={1.851}
        y2={1.851}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="bcv"
        x1={213.352}
        x2={724.999}
        y1={2.148}
        y2={2.148}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="ccv"
        x1={737}
        x2={737}
        y1={0}
        y2={4}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
